/// <amd-module name="Agile/Common/Redux/TeamSettings/TeamSettingsContracts" />
import { ITeamSettings } from "Agile/Contracts/Common";

export interface ITeamSettingsAwareState {
    teamSettingsState: ITeamSettingsState;
}

export interface ITeamSettingsState {
    teamSettings: ITeamSettings;
}
